"use client";

import type { FC, Ref } from "react";
import { GraphCard, type GraphProps } from "@huub-web/ui";

export interface GraphCardTemplateProps extends GraphProps {
  title: string;
}

export const GraphCardTemplate: FC<
  GraphCardTemplateProps & { ref?: Ref<HTMLDivElement> }
> = ({ title, ref, ...props }) => (
  <GraphCard title={title} {...props} ref={ref} />
);
